module.exports = __webpack_public_path__ + "img/pink-cart-bold-20x20.ba435c33.svg";